import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Radio(theme: Theme): Components<Theme> {
  return {
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          "& svg": {
            fontSize: 24,
          },
          "& .MuiSvgIcon-fontSizeSmall": {
            fontSize: 20,
          },
        },
      },
    },
  };
}
